import { LOCALES } from '@marketplace/i18n';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { landingPageHeader } from '../../../../../libs/common/src/components/header/header.i18n';
import { landingPageMainSection } from './main-section/main-section.i18n';
import { landingPageBanner } from './banner/banner.i18n';
import { landingPageFooter } from '../layouts/landing-layout/footer/footer.i18n';
import { authAgreementDialogI18n } from '../../features/auth/auth-agreement-dialog';

export const landingPageI18n = {
  [LOCALES.ENG]: {
    ...authAgreementDialogI18n[LOCALES.ENG],
    ...landingPageHeader[LOCALES.ENG],
    ...landingPageBanner[LOCALES.ENG],
    ...landingPageMainSection[LOCALES.ENG],
    ...landingPageFooter[LOCALES.ENG],
    developer_landing_deactivated_user_dialog_title: 'User is deactivated',
    developer_landing_deactivated_user_dialog_message:
      'Your account is deactivated, to get more details please reach out Developer Platform admin',
  },
};
